import React, { useEffect, useState } from "react";
import { CCard, CCardBody } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilCalculator, cilX } from "@coreui/icons";
import "./Floating_Calculator.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";

const Floating_Calculator = () => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");

  const buttons = [
    ["√", "%", "⌫", "AC"],
    ["7", "8", "9", "+"],
    ["4", "5", "6", "×"],
    ["1", "2", "3", "÷"],
    ["0", ".", "-", "="],
  ];

  const handleClick = (btn) => {
    if (btn === "AC") return setValue("");
    if (btn === "⌫") return setValue(value.slice(0, -1));

    if (btn === "%") {
      try {
        const parts = value.split(/([+\-×÷])/);
        if (parts.length === 1) {
          setValue((parseFloat(value) / 100).toString());
        } else {
          const lastNumber = parseFloat(parts.pop());
          const operator = parts.pop();
          const base = eval(parts.join("").replace("×", "*").replace("÷", "/"));
          setValue(`${base}${operator}${(base * lastNumber) / 100}`);
        }
      } catch {
        setValue("Error");
      }
      return;
    }

    if (btn === "=") {
      try {
        setValue(eval(value.replace("×", "*").replace("÷", "/")).toString());
      } catch {
        setValue("Error");
      }
      return;
    }

    if (btn === "√") {
      try {
        setValue(Math.sqrt(parseFloat(value)).toString());
      } catch {
        setValue("Error");
      }
      return;
    }

    setValue(value + btn);

  };


  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (e) => {
      const key = e.key;

      // Numbers
      if (key >= "0" && key <= "9") {
        handleClick(key);
      }

      // Operators
      if (key === "+") handleClick("+");
      if (key === "-") handleClick("-");
      if (key === "*") handleClick("×");
      if (key === "/") handleClick("÷");

      // Decimal
      if (key === ".") handleClick(".");

      // Equals
      if (key === "Enter") {
        e.preventDefault();
        handleClick("=");
      }

      // Backspace
      if (key === "Backspace") handleClick("⌫");

      // Clear
      if (key === "Escape") handleClick("AC");

      // Square root (optional shortcut)
      if (key.toLowerCase() === "r") handleClick("√");
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, value]);




  return (
    <>
      {/* Floating Icon */}
      {!open && (
        <button
          className="floating-calculator-btn"
          onClick={() => setOpen(true)}
        >
          <FontAwesomeIcon icon={faCalculator} className="inner_icon" />
        </button>
      )}

      {/* Calculator */}
      {open && (
        <CCard className="floating-calculator-box">
          {/* Close Button */}
          <button
            className="calculator-close-btn"
            onClick={() => setOpen(false)}
          >
            <CIcon icon={cilX} />
          </button>

          {/* Calculator UI */}
          <div className="calculator-container">
            {/* Display */}
            <div className="calculator-display">
              <div className="calculator-value">{value || "0"}</div>
            </div>

            {/* Buttons */}
            <div className="calculator-buttons">
              {buttons.flat().map((btn, index) => (
                <button
                  key={index}
                  className={`calc-btn
                      ${btn === "AC" ? "btn-ac" : ""}
                      ${btn === "=" ? "btn-equal" : ""}
                      ${["+", "-", "×", "÷"].includes(btn) ? "btn-operator" : ""
                    }
                    `}
                  onClick={() => handleClick(btn)}
                >
                  {btn}
                </button>
              ))}
            </div>
          </div>
        </CCard>
      )}
    </>
  );
};

export default Floating_Calculator;
